import Chart from 'chart.js/auto';

const lineChart = async(ctx, indexes, label, data)=> {
    return new Chart(ctx, {
        type: "line",
        data: {
          labels: indexes,
          datasets: [
            {
              label,
              data,
              fill: false,
                  borderColor: "rgb(76, 192, 192)",
              tension: 0.1,
              borderWidth: 1
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
            x: {
              display: false
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: false
            }
          },
          elements: {
            point:{
              radius: 0
            }
          }
        },
      });
};

export {
    lineChart
}